import { Component, OnInit, OnDestroy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

interface CrumbItem {
  label: string;
  url: string;
  icon?: string;
  isActive: boolean;
}

@Component({
  selector: 'app-crumbs',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
],
  templateUrl: './crumbs.component.html',
  styleUrl: './crumbs.component.scss'
})
export class CrumbsComponent implements OnInit, OnDestroy {
  crumbs: CrumbItem[] = [];
  private destroy$ = new Subject<void>();

  private readonly routeConfig: { [key: string]: { label: string; icon?: string } } = {
    // Route segments

    //Administrator dashboard
    'municipalities': { label: 'Općine', icon: 'groups' },
    'users': { label: 'Korisnici', icon: 'groups' },

    //Municipality + Association dashboards
    'associations': { label: 'Udruge', icon: 'groups' },
    'grants': { label: 'Natječaji', icon: 'campaign' },
    'notifications': { label: 'Obavijesti', icon: 'notifications' },
    'applications': { label: 'Prijave', icon: 'fact_check' },
    'allocations': { label: 'Izravne dodjele', icon: 'monetization_on' },
    'projects': { label: 'Projekti', icon: 'work' },
    'budgets': { label: 'Proračuni', icon: 'money' },
    'contracts': { label: 'Ugovori', icon: 'description' },
    'refunds': { label: 'Povrati', icon: 'undo' },
    'saldo': { label: 'Saldo', icon: 'balance' },
    'reports': { label: 'Izvještaji', icon: 'bar_chart' },
    'reviews': { label: 'Ocjenjivanje', icon: 'rate_review' },
     
    // Action segments
    'create': { label: 'Kreiranje', icon: 'add' },
    'edit': { label: 'Uređivanje', icon: 'edit' },
    'view': { label: 'Pregled', icon: 'visibility' },
    'comply': { label: 'Formalni uvjeti', icon: 'check_circle' },
    'review': { label: 'Ocijeni', icon: 'rate_review' }
  };

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
    // Build initial breadcrumbs
    this.buildCrumbs();

    // Listen to route changes
    this.router.events
      .pipe(
       filter(event => event instanceof NavigationEnd),
       takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.buildCrumbs();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private buildCrumbs(): void {
    const url = this.router.url;
    const segments = url.split('/').filter(segment => segment)
    
    this.crumbs = [];
    let currentUrl = '';

    segments.forEach((segment, index) => {
      currentUrl += `/${segment}`;
      const config = this.routeConfig[segment];
      
      if (config) {
        this.crumbs.push({
          label: config.label,
          url: currentUrl,
          icon: config.icon,
          isActive: index === segments.length - 1
        });
      }
    });
  }

 onCrumbClick(crumb: CrumbItem): void {
    if (!crumb.isActive) {
        this.router.navigate([crumb.url], {
          state: history.state
        });
    }
  }

  trackByUrl(index: number, item: CrumbItem): string {
    return item.url;
  }
}
